import { ToolTip } from 'components/controls';
import NameCellWithImage from 'components/controls/image-cell';
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type WebsitesColumns = {
    domain: string;
    createdAt: string;
    companyId: string;
};

export const useWebsiteTableColums = (): MRT_ColumnDef<WebsitesColumns>[] => {
    const { t } = useTranslation();

    return useMemo(
        () => [
            {
                accessorKey: 'domain',
                header: t('TABLE_HEADERS.DOMAIN'),
                enableColumnActions: false,
                Cell: ({ cell }) => {
                    const domain = cell.row.original.domain;
                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['domain'].length < 40}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage cell={cell} isLink path={`https://${domain}`} />
                        </ToolTip>
                    );
                },
                size: 400,
            },
            {
                id: 'companyId',
                accessorKey: 'companyName',
                header: t('TABLE_HEADERS.COMPANY'),
                filterVariant: 'autocomplete',
                filterSelectOptions: [],
                size: 170,
                enableColumnActions: false,
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                size: 100,
                enableColumnActions: false,
                enableColumnFilter: false,
            },
        ],
        [t],
    );
};
